var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageSpecialist"}},[_c('dashboard'),_c('barraLateral'),(_vm.completed == 'false')?_c('modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }